<template>
  <ListView
    :title="title"
    @reload="reload"
    @create="actionCreate"
    @navDetails="actionDetails"
    :enable-create="true"
    :search.sync="search"
    :data="data"
    :limit="limit"
    :page.sync="page"
    :header="computedHeader"
    :search-box-placeholder="placeholder"
  >
    <!-- TODO: enable create after the new user api is ready -->
    <template v-if="selectedRole === 'customer'" v-slot:filterRight>
      <v-select v-model="birthday" :items="month" clearable flat label="Birthday Month" outlined />
    </template>
    <template v-slot:card="{ cardContent }">
      <Card :content="cardContent" class="clickable" @click.native="actionDetails(cardContent)" />
    </template>
    <!-- <template v-slot:item.phone="{ item }"> {{ item.countryCode }} {{ item.phone }} </template> -->
    <template v-slot:item.phone="{ item }"> {{ item.phone }} </template>
    <template v-slot:item.createdAt="{ item }">
      {{ item.createdAt | moment }}
    </template>
    <template v-slot:item.gender="{ item }">
      {{ item.gender | translateOptions(profileGenderOption, 'value', 'text') }}
    </template>
    <template v-slot:item.genderPreference="{ item }">
      {{ item.genderPreference | translateOptions(profileGenderPreferenceOption, 'value', 'text') }}
    </template>
    <template v-slot:item.locationDistrict="{ item }">
      {{ item.locationDistrict | translateOptions(districtsOptions, 'value', 'label') }}
    </template>
    <template v-slot:item.vipStatus="{ item }">
      <span v-if="get(item, 'vipStatus.isActive') === true">Active</span>
      <span v-else>-</span>
    </template>

    <template v-if="selectedRole === 'bn.master'" v-slot:filterRight>
      <div style="width: 200px">
        <v-select
          v-model="selectedStatus"
          :items="profileStatuses"
          item-value="value"
          item-text="text"
          clearable
          flat
          label="Status"
          outlined
        />
      </div>
    </template>
    <IdentityEditDialog
      v-model="editDialog"
      :id="editId"
      :title="title"
      :role="selectedRole"
      @create="reload"
      @update="reload"
      @delete="reload"
    />
  </ListView>
</template>

<script>
import listViewPageMixin from '@/services/listViewPageMixin';
import Card from '@/components/Identity/IdentityCard';
import IdentityEditDialog from '@/components/Identity/IdentityEditDialog';
import { mapGetters } from 'vuex';
import { RESTFUL, roles } from '@/data/constants';
import { decapitalize, translateOptions } from '@/services/filters';
import {
  month,
  roleOptions,
  profileGenderOption,
  profileGenderPreferenceOption,
  districtsOptions,
} from '@/data/optionsConstants';
import { ProfileStatus } from '@/api/auth/membership';
import moment from 'moment';
import { get } from 'lodash';

export default {
  name: 'profiles',
  props: {
    selectedRole: {},
  },
  mixins: [listViewPageMixin],
  components: { IdentityEditDialog, Card },
  data() {
    return {
      profileGenderOption,
      profileGenderPreferenceOption,
      districtsOptions,
      month: month,
      header: [
        { text: 'Name', value: 'name', width: '280px' },
        // { text: 'SID', value: 'sid', width: '200px' },
        // { text: 'Phone', value: 'phone', width: '200px' },
        { text: 'Created At', value: 'createdAt', width: '200px' },
      ],
      birthday: null,
      selectedStatus: null,
    };
  },
  computed: {
    ...mapGetters('auth', ['role', 'isMaster']),
    restfulURL() {
      let out = RESTFUL.profile.list;
      // if (!this.isMaster) {
      //   if (this.selectedRole === 'customer') {
      //     out = RESTFUL.clientProfile.list;
      //   }
      //   if (this.selectedRole === 'bn.master') {
      //     out = RESTFUL.masterProfile.list;
      //   }
      // } else {
      //   if (this.selectedRole === 'customer') {
      //     out = RESTFUL.clientProfile.masterList;
      //   }
      // }
      return out;
    },
    computedHeader() {
      if (this.selectedRole === 'customer') {
        return [
          { text: 'Name', value: 'name', width: '200px' },
          { text: 'Phone', value: 'phone', width: '180px' },
          { text: 'Gender', value: 'gender' },
          { text: 'Gender Preference', value: 'genderPreference' },
          { text: 'District', value: 'locationDistrict' },
          { text: 'VIP Status', value: 'vipStatus' },
          { text: 'Created At', value: 'createdAt', width: '200px' },
        ];
      }
      return this.header;

      // return this.selectedRole === 'customer'
      //   ? [...this.header, { text: 'Credit', value: 'creditBalance', width: '300px' }]
      //   : this.selectedRole === 'bn.master'
      //   ? [...this.header, { text: 'Display Order', value: 'bnDisplayOrder', width: '100px' }]
      //   : this.header;
    },
    // filter() {
    //   return {
    //     role: this.selectedRole || null,
    //     birthday: this.birthday && this.selectedRole === 'customer' ? this.birthday : undefined,
    //     status: this.selectedStatus ? this.selectedStatus : undefined,
    //   };
    // },
    filter() {
      return {
        role: this.selectedRole || undefined,
      };
    },
    title() {
      return this.selectedRole
        ? `Accounts-${translateOptions(this.selectedRole, roleOptions)}`
        : `Accounts`;
    },
    profileStatuses() {
      return [
        { text: 'Active', value: ProfileStatus.accepted },
        { text: 'Inactive', value: ProfileStatus.rejected },
      ];
    },
    placeholder() {
      if (this.selectedRole === 'customer') {
        return 'Search by Name / Phone';
      }
      return 'Search by Name';
    },
  },
  methods: {
    get,
    actionCreate() {
      this.$router.push({ name: 'profileNew', query: { role: this.selectedRole } });
    },
  },
};
</script>

<style scoped lang="scss">
.selectedItem ::v-deep .v-select__selection--comma {
  margin-bottom: -25px;
}

.role {
  top: 10px;
  position: absolute;
  left: 24px;
  color: var(--v-success-base);
}
</style>
